import type { MultiSelectOption } from '@/components/ui/multi-select-form-field';

/**
 * Convert string array to MultiSelectOption format
 * Used for migrating from old multi-select component to new one
 */
export const stringArrayToOptions = (
	strings: string[]
): MultiSelectOption[] => {
	if (!strings || !Array.isArray(strings)) return [];
	return strings.map((str) => ({
		label: str,
		value: str,
	}));
};

/**
 * Convert MultiSelectOption array back to string array if needed
 */
export const optionsToStringArray = (
	options: MultiSelectOption[]
): string[] => {
	if (!options || !Array.isArray(options)) return [];
	return options.map((opt) => opt.value);
};

/**
 * Create unique options from multiple string arrays
 * Useful when combining tags with existing values
 */
export const createUniqueOptions = (
	...arrays: (string[] | undefined)[]
): MultiSelectOption[] => {
	const combined = arrays
		.filter((arr) => arr !== undefined)
		.flat() as string[];
	const uniqueStrings = [...new Set(combined)];
	return stringArrayToOptions(uniqueStrings);
};
